import * as echarts from 'echarts/core'
import { PieChart, BarChart } from 'echarts/charts'
import {
  AriaComponent,
  GraphicComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
} from 'echarts/components'
import { LabelLayout } from 'echarts/features'
import { SVGRenderer } from 'echarts/renderers'

echarts.use([
  AriaComponent,
  GraphicComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  LabelLayout,
  PieChart,
  BarChart,
  SVGRenderer,
])

export { echarts }
